import { Link } from "react-router-dom";
import type { AtomicAsset } from "../types";
import { assetImageHash, formatAssetName } from "../utils/backing";
import { BackedBadge } from "./BackedBadge";
import { IpfsImage } from "./IpfsImage";

interface AssetCardProps {
  asset: AtomicAsset;
  price?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
}

export function AssetCard({ asset, price, actionLabel, onAction, actionDisabled }: AssetCardProps) {
  const imgHash = assetImageHash(asset);

  return (
    <div className="asset-card">
      <Link to={`/asset/${asset.asset_id}`} className="asset-card__media-link">
        <div className="asset-card__media">
          <IpfsImage hash={imgHash} alt={formatAssetName(asset)} loading="lazy" />
          <BackedBadge asset={asset} />
        </div>
      </Link>
      <div className="asset-card__body">
        <div className="asset-card__collection">{asset.collection?.name || asset.collection?.collection_name}</div>
        <Link to={`/asset/${asset.asset_id}`} className="asset-card__name">
          {formatAssetName(asset)}
        </Link>
        <div className="asset-card__footer">
          {price ? <span className="asset-card__price">{price}</span> : <span />}
          {actionLabel && onAction && (
            <button className="btn btn--small" onClick={onAction} disabled={actionDisabled}>
              {actionLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
